import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";
import defaultInstance from "../../axiosHelper";
import { API_ENDPOINTS } from "../../utils/apiEndPoints";
import { ROLE_TYPE } from "../../utils/helper";
import { setSessionFilter } from "../../utils/sessionStorage";
import { districtFilter } from "../../utils/helper";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const onSubmit = async (evt) => {
    evt.preventDefault();
    const apiPayload = { email, password }
    try {
      const response = await defaultInstance.post(API_ENDPOINTS.LOGIN, apiPayload);
      if (response?.data?.token) {
        const userData = response?.data?.user_info;
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("user_id", response?.data?.user_id);
        localStorage.setItem("user_data", JSON.stringify(userData));
        localStorage.setItem("district_info", JSON.stringify(response?.data?.hasDistrictInfo));
        // Set role type in session storage based on user role
        let roleType = ROLE_TYPE.FIELD_COORDINATOR;
        let targetPath = "/home";

        switch (userData.role) {
          case 'State Coordinator':
            roleType = ROLE_TYPE.STATE_COORDINATOR;
            targetPath = "/dashboard-overview";
            break;
          case 'Assistant State Coordinator':
            roleType = ROLE_TYPE.ASSISTANT_STATE_COORDINATOR;
            targetPath = "/dashboard-overview";
            break;
          case 'Zonal Manager':
            roleType = ROLE_TYPE.ZONAL_MANAGER;
            targetPath = "/dashboard-overview";
            break;
          case 'Supervisor':
            roleType = ROLE_TYPE.SUPER_VISOR;
            targetPath = "/dashboard-overview";
            break;
          case 'admin':
            targetPath = "/admin-home";
            break;
          case 'Field Coordinator':
          default:
            targetPath = response?.data?.hasDistrictInfo ? "/FieldDashboard" : "/home";
            break;
        }

        // Save role type to session storage
        setSessionFilter('dashboardFilter', { from_date: districtFilter().from_date, to_date: districtFilter().to_date, role_type: roleType });

        navigate(targetPath);

      } else {
        setError("Invalid email or password");
      }
    } catch (error) {
      setError("Invalid email or password");
    }
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={onSubmit}>
        <h2>Sign In</h2>
        {error && <p className="error-message">{error}</p>}
        <div className="form-group">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter Your Email"
            required
          />
        </div>
        <div className="form-group">
          <div className="password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              required
            />
            <span
              className="eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
        </div>
        <div className="form-group">
          <a href="/forgot-password" className="forgot-password-link">
            Forget Password?
          </a>
        </div>
        <button type="submit" className="login-button">
          Sign In
        </button>
      </form>
    </div>
  );
};

export default Login;
